'use strict';

// var $ = require("jquery");
// window.jQuery = $;
// require("@fancyapps/fancybox");

document.addEventListener("DOMContentLoaded", () => {

  const bg = document.querySelector("#bg");
  const scrollHorizon = function() {
    let scrollH = document.documentElement.scrollHeight || document.body.scrollHeight; //ドキュメントの長さ
    let scrollV = scrollH - window.innerHeight; //ウィンドウの高さを引くことで実際にスクロールする量を取得
    let windowY = window.pageYOffset;
    bg.style.backgroundPosition = (100 - ((windowY / scrollV) * 100)) + "% 0";
  };

  const button = document.querySelector("#flavor");
  const target = document.querySelector("body");
  const changeClass = function() {
    if (target.classList.contains("showflavor")) {
      target.classList.remove("showflavor");
      target.classList.add("hideflavor");
    }

    window.addEventListener("scroll", function() {
      scrollHorizon();
    }, false);
  };

  button.addEventListener("click", changeClass, false);
  setTimeout(() =>
    changeClass(), 10000
  );

}, false);



// WEBPACK FOOTER //
// ./src/js/script.js